<template>
  <v-container grid-list-sm fluid>
    <v-layout d-flex wrap>
      <v-flex sm12 class="pa-2">
        <v-expansion-panels popout v-model="panelActivo" multiple>
          <v-expansion-panel style="width: 100vw">
            <v-expansion-panel-header class="title transparent"
              >Intereses</v-expansion-panel-header
            >
            <v-expansion-panel-content class="mt-2">
              <div v-if="!editIntereses">
                <div v-if="userData.intereses.length">
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in userData.intereses"
                      :key="`listinteres${index}`"
                      class="my-1"
                    >
                      <v-list-item-icon>
                        <v-icon color="green"
                          >mdi-check-underline-circle</v-icon
                        >
                      </v-list-item-icon>

                      <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </div>
                <div
                  v-else
                  class="d-flex align-center justify-center mt-4 text--disabled"
                >
                  Añade los diferentes temas que te interesen.
                </div>
              </div>
              <div v-else>
                <div class="d-flex flex-column">
                  <div class="d-flex justify-end">
                    <v-btn dark small color="green" @click="agregarInteres">
                      <v-icon left>mdi-plus-circle</v-icon>Agregar
                    </v-btn>
                  </div>
                  <div
                    v-if="interesesList.length == 0"
                    class="d-flex justify-center mt-2 text--disabled"
                  >
                    Aquí se agregarán los intereses que añadas
                  </div>

                  <div
                    v-for="(info, index) in interesesList"
                    :key="`editinteres${index}`"
                    class="d-flex pa-2 flex-column blue-grey lighten-5 my-2"
                    style="border-radius: 15px"
                  >
                    <div class="d-flex justify-space-around">
                      <p class="mx-2 my-auto font-weight-bold">
                        {{ index + 1 }}.
                      </p>
                      <v-text-field
                        v-model="interesesList[index]"
                        label="Me interesa..."
                      ></v-text-field>
                      <v-btn
                        text
                        icon
                        color="green"
                        @click="eliminarInfoInteres(index)"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
              <v-divider class="mt-4"></v-divider>
              <v-card-actions>
                <v-btn text v-if="editIntereses" @click="editIntereses = false"
                  >Cancelar</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  :loading="fetching"
                  :disabled="fetching"
                  @click="actionBtnIntereses"
                >
                  <v-icon left color="green"
                    >mdi-{{
                      editIntereses ? 'content-save-edit' : 'plus-circle'
                    }}</v-icon
                  >
                  {{ editIntereses ? 'Guardar' : 'Editar' }}
                </v-btn>
              </v-card-actions>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel style="width: 100vw">
            <v-expansion-panel-header class="title transparent"
              >Publicaciones</v-expansion-panel-header
            >
            <v-expansion-panel-content class="mt-2">
              <div v-if="editPublicaciones">
                <div class="d-flex flex-column">
                  <div class="d-flex justify-end">
                    <v-btn dark small color="lime" @click="agregarPublicacion">
                      <v-icon left>mdi-plus-circle</v-icon>Agregar
                    </v-btn>
                  </div>
                  <div
                    v-if="publicacionesList.length == 0"
                    class="d-flex justify-center mt-4 text--disabled lime--text">
                    Aquí se agregarán las diferentes publicaciones que añadas
                  </div>

                  <div
                    v-for="(info, index) in publicacionesList"
                    :key="`publicacedit${index}`"
                    class="d-flex pa-2 flex-column blue-grey lighten-5 my-2"
                    style="border-radius: 15px"
                  >
                    <div class="d-flex justify-space-between">
                      <p class="mx-2 my-auto font-weight-bold">
                        {{ index + 1 }}.
                      </p>
                      <v-btn
                        text
                        color="red"
                        @click="eliminarInfoPublicacion(index)">Eliminar</v-btn>
                    </div>

                    <div class="d-flex justify-space-around">
                      <v-text-field
                        v-model="publicacionesList[index].titulo"
                        counter="150"
                        label="Título de la publicación"
                        class="mx-2"></v-text-field>
                      <v-text-field
                        v-model="listaPalabrasClave[index]"
                        label="Palabras Clave"
                        hint="Separa las palabras clave con comas"
                        class="mx-2"></v-text-field>
                    </div>
                    <div class="d-flex justify-space-around">
                      <!-- <v-textarea
                        name="resumenPublicacion"
                        filled
                        label="Resumen de Publicación"
                        auto-grow
                        counter="5000"
                        v-model="publicacionesList[index].resumenPublicacion"
                      ></v-textarea> -->
                      <VueEditor
                        id="pub-cotent-editor"
                        v-model="publicacionesList[index].resumenPublicacion"
                        placeholder="Resumen de Publicación">
                      </VueEditor>
                    </div>
                    <div class="d-flex justify-space-around">
                      <v-text-field
                        v-model="publicacionesList[index].linkReferencia"
                        label="Link de la publicación"
                        prepend-inner-icon="mdi-link-variant-plus"
                        :rules="urlFieldRule"
                      ></v-text-field>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div
                  v-if="!userData.publicaciones.length"
                  class="d-flex align-center justify-center mt-4 text--disabled">
                  Añade las diferentes publicaciones en las que participaste.
                </div>
                <div v-else>
                  <v-list-item-group>
                    <template v-for="(item, index) in userData.publicaciones">
                      <v-list-item :key="`publiclist${index}`">
                        <v-list-item-content>
                          <v-list-item-title
                            class="font-weight-bold"
                            v-text="item.titulo"
                          ></v-list-item-title>
                          <v-list-item-subtitle
                            class="text--primary mt-2"
                            v-html="item.resumenPublicacion"
                          ></v-list-item-subtitle>
                          <v-list-item-subtitle
                            class="text--secondary mt-2"
                            v-if="item.palabrasClave.some((i) => i != '')"
                            >Palabras clave:
                            {{ getPalabrasClave(item) }}</v-list-item-subtitle
                          >
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn
                            text
                            icon
                            color="blue"
                            target="_blank"
                            :href="item.linkReferencia"
                          >
                            <v-icon large>mdi-open-in-new</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                      <v-divider
                        v-if="index + 1 < item.length"
                        :key="index"
                      ></v-divider>
                    </template>
                  </v-list-item-group>
                </div>
              </div>
              <v-divider
                v-if="!userData.publicaciones.length"
                class="mt-4"
              ></v-divider>
              <v-card-actions>
                <v-btn
                  text
                  v-if="editPublicaciones"
                  @click="cancelEditPublicaciones"
                  >Cancelar</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn text @click="actionBtnPublicaciones">
                  <v-icon left color="lime" :loading="fetching"
                    >mdi-{{
                      editPublicaciones ? 'content-save-edit' : 'plus-circle'
                    }}</v-icon
                  >
                  {{ editPublicaciones ? 'Guardar' : 'Editar' }}
                </v-btn>
              </v-card-actions>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { VueEditor } from 'vue2-editor';

export default {
  props: ['userData'],
  components: {
    VueEditor
  },
  data: function () {
    return {
      panelActivo: [0, 1],
      editIntereses: false,
      interesesList: [],
      editPublicaciones: false,
      publicacionesList: [],
      listaPalabrasClave: [],
      urlFieldRule: [
        (v) =>
          (v &&
            /https?:\/\/(www\.)?[-a-zA-Z0-9@:%.+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%+.~#?&//=]*)/.test(
              v
            )) ||
          'Usa el formato: http://www.ejemplo.com'
      ]
    };
  },

  methods: {
    agregarInteres () {
      this.interesesList.push('');
    },

    async actionBtnIntereses () {
      if (this.editIntereses) {
        let response = await this.updateProfileInfo({
          intereses: this.interesesList
        });
        if (response.success) {
          this.editIntereses = false;
          this.userData.intereses = this.cleanSource(this.interesesList);
        }
      } else {
        this.interesesList = this.cleanSource(this.userData.intereses);
        this.editIntereses = true;
      }
    },

    eliminarInfoInteres (index) {
      this.interesesList.splice(index, 1);
    },

    async actionBtnPublicaciones () {
      if (this.editPublicaciones) {
        let [...lista] = this.publicacionesList;
        let body = {
          publicaciones: lista
        };

        // console.log(body)
        // console.log(this.listaPalabrasClave)

        // let keywords = this.publicacionesList.palabrasClave;
        this.listaPalabrasClave.forEach((item, index) => {
          body.publicaciones[index].palabrasClave = this.listaPalabrasClave[index].split(',');
        });

        for (let i = 0; i < body.publicaciones.length; i++) {
          for (let j = 0; j < body.publicaciones[i].palabrasClave.length; j++) {
            body.publicaciones[i].palabrasClave[j] = body.publicaciones[i].palabrasClave[j].trim();
          }
        }

        let response = await this.updateProfileInfo(body);

        if (response.success) {
          this.editPublicaciones = false;
          this.listaPalabrasClave = [];
          this.userData.publicaciones = this.cleanSource(this.publicacionesList);
        }
      } else {
        this.editPublicaciones = true;
        this.publicacionesList = [...this.userData.publicaciones];
        this.publicacionesList.forEach((element, index) => {
          let [...palabrasClave] = element.palabrasClave;
          let keywordsJoined = palabrasClave.join(', ');
          this.listaPalabrasClave.push(keywordsJoined);
        });
      }
    },

    agregarPublicacion () {
      this.publicacionesList.push({
        titulo: '',
        resumen: '',
        palabrasClave: []
      });
      this.listaPalabrasClave.push('');
    },

    eliminarInfoPublicacion (index) {
      this.publicacionesList.splice(index, 1);
      this.listaPalabrasClave.splice(index, 1);
    },

    cancelEditPublicaciones () {
      this.editPublicaciones = false;
      // this.listaPalabrasClave = []
    },

    getPalabrasClave (item) {
      let [...palabrasClave] = item.palabrasClave;
      let keywordsJoined = palabrasClave.join(', ');
      return keywordsJoined;
    },

    cleanSource (source) {
      // using native JSON functions removes reactivity
      // so we can clone an object without mutating the original source
      return JSON.parse(JSON.stringify(source));
    },

    ...mapActions('user', ['updateProfileInfo'])
  },

  computed: {
    ...mapGetters('user', ['getError', 'fetching'])
  }
};
</script>

<style>
.v-list-item__title {
  white-space: pre-wrap; /* Since CSS 2.1 */
  white-space: -moz-pre-wrap; /* Mozilla */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer */
}
.quillWrapper {
  width: 100%;
  margin-bottom: 50px;
}
</style>
